import { render, staticRenderFns } from "./QualityRecords.vue?vue&type=template&id=95d5e484&scoped=true"
import script from "./QualityRecords.vue?vue&type=script&lang=js"
export * from "./QualityRecords.vue?vue&type=script&lang=js"
import style0 from "./QualityRecords.vue?vue&type=style&index=0&id=95d5e484&prod&lang=css"
import style1 from "./QualityRecords.vue?vue&type=style&index=1&id=95d5e484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d5e484",
  null
  
)

export default component.exports